import { memo } from 'react'
import type { FC } from 'react'
import { Group, Avatar, Text, ActionIcon, Box } from 'components'
import { IconPlus, IconMinus } from '@tabler/icons-react'
import { getInitials } from 'helpers'
import type { StudentListItemProps } from './types'

export const StudentListItem: FC<StudentListItemProps> = memo(({
  student,
  onAction,
  actionType,
}) => {
  const fullName = `${student.firstName} ${student.lastName}`
  const initials = getInitials(fullName)

  return (
    <Box
      py={6}
      px={4}
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: 44,
        borderRadius: 8,
        transition: 'background-color 0.15s ease',
        '&:hover': {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : '#f5f5f5',
        },
      })}
    >
      <Group spacing={10} noWrap>
        <Avatar
          size={28}
          radius="xl"
          src={student.avatar}
          color="gray"
          styles={{
            root: {
              backgroundColor: '#e9ecef',
              flexShrink: 0,
            },
            placeholder: {
              backgroundColor: '#e9ecef',
              color: '#495057',
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: '0.3px',
            },
          }}
        >
          {initials}
        </Avatar>
        <Text size="sm" color="#333" weight={400} lineClamp={1}>
          {fullName}
        </Text>
      </Group>

      <ActionIcon
        onClick={onAction}
        variant="filled"
        radius="xl"
        size={26}
        sx={{
          backgroundColor: actionType === 'add' ? 'var(--arc-primary, #20927d)' : '#fa5252',
          flexShrink: 0,
          '&:hover': {
            backgroundColor: actionType === 'add' ? 'var(--arc-primary-hover, #1b7d6b)' : '#e03131',
          },
        }}
      >
        {actionType === 'add' ? (
          <IconPlus size={14} color="white" stroke={2.5} />
        ) : (
          <IconMinus size={14} color="white" stroke={2.5} />
        )}
      </ActionIcon>
    </Box>
  )
})

StudentListItem.displayName = 'StudentListItem'
